import MuiPaper, { PaperProps } from "@mui/material/Paper";
import React from "react";

export const Paper: React.FC<PaperProps> = (props) => {
  return <MuiPaper {...props} />;
};
